import DOMPurify from 'dompurify';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';
import { TooltipProps } from '@/types';

function TooltipWrapper({ children, text, className }: TooltipProps) {
  // In PublishProjectModal.tsx we are forwarding the HTML content
  const isHTML = /<\/?[a-z][\s\S]*>/i.test(text);
  // If in future we get HTML from the BE, like for the summary in TranscriptsColumns.tsx
  // we can sanitize it here, but we will need to set additional allowed tags and attributes
  const sanitizedText = DOMPurify.sanitize(text || '', {
    ALLOWED_TAGS: ['li', 'p'],
    ALLOWED_ATTR: ['class'],
  });

  return (
    <TooltipProvider>
      <Tooltip delayDuration={50}>
        <TooltipTrigger asChild>{children}</TooltipTrigger>
        <TooltipContent className={className}>
          {isHTML ? <div dangerouslySetInnerHTML={{ __html: sanitizedText }} /> : <p>{text}</p>}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}

export default TooltipWrapper;
